import Spinner from "./Spinner";
import ErrorFallback from "@/pages/error 404/ErrorFallback";

type Props = {
  isLoading: boolean;
  isError: boolean;
  children: React.ReactNode;
};

/**
 * QueryStateWrapper - مكون شامل لإدارة حالات التحميل والأخطاء
 *
 * يستخدم الآن spinner.svg المحسن مع animation loop جميل
 *
 * الاستخدام:
 * <QueryStateWrapper isLoading={isLoading} isError={!!error}>
 *   // محتوى الصفحة هنا
 * </QueryStateWrapper>
 */
const QueryStateWrapper = ({ isLoading, isError, children }: Props) => {
  if (isLoading) return <Spinner />;
  if (isError) return <ErrorFallback />;
  return <>{children}</>;
};

export default QueryStateWrapper;
